import { Command } from 'commander'
import { createApiClient, SCOPES } from '../http.js'
import { getMyPublisher } from '../registry.js'

export function registerPublisher(program: Command): void {
  const publisherCmd = program.command('publisher').description('Manage your publisher profile')

  publisherCmd
    .command('create')
    .description('Onboard your account as a marketplace publisher')
    .requiredOption('--name <name>', 'URL-safe publisher name (e.g. acme)')
    .requiredOption('--display-name <displayName>', 'human-readable publisher name')
    .option('--description <description>')
    .option('--website <url>')
    .option('--email <email>')
    .action(async (options: { name: string; displayName: string; description?: string; website?: string; email?: string }) => {
      const api = await createApiClient()
      const existing = await getMyPublisher(api)
      if (existing) {
        console.log(`This account already has publisher '${existing.name}'.`)
        return
      }
      const id = await api.request<string>('POST', '/v1/publishers', {
        scopes: [SCOPES.publisherCreate],
        body: {
          name: options.name,
          displayName: options.displayName,
          description: options.description ?? null,
          websiteUrl: options.website ?? null,
          contactEmail: options.email ?? null,
        },
      })
      console.log(`Publisher '${options.name}' created (${id}).`)
      console.log('Next: generate and register a signing key with `verentis keygen`.')
    })
}
